<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: Radio
 */
import type { BtnRadioProps } from '../types/interfaces'

import { AppIcon } from '@shared/ui/icons'

import { useBtnRadio } from '../composables/use-btn-radio.hook'

defineOptions({
  name: 'BtnRadio',
})

const props = withDefaults(defineProps<BtnRadioProps>(), {
  label: '',
  checked: false,
  disabled: false,
})

const emit = defineEmits<{
  click: []
}>()

const {
  refIcon,
  handleClick,
} = useBtnRadio({
  props,
  onClick: () => emit('click'),
})
</script>

<template>
  <button
    type="button"
    role="radio"
    :aria-checked="checked"
    :aria-label="label || undefined"
    :class="['btn-radio', { checked, disabled, 'icon-only': !text }]"
    :disabled="disabled"
    @click="handleClick"
  >
    <AppIcon
      :icon="refIcon"
      size="small"
      class="btn-radio__icon"
    />
    <span
      v-if="text"
      class="btn-radio__text"
    >
      {{ text }}
    </span>
  </button>
</template>

<style lang="scss" scoped src="../styles/_btn-radio.scss" />
